import React, { useState } from "react";
import "../../../../Style/ECOSidebar/ECOSidebar.scss";
import { Select, Radio, Input, Col, Form, DatePicker, Button } from "antd";

import { useLocation } from "react-router-dom";
export default function ECOSidebar() {
  const location = useLocation();
  const onChange = (value) => {
    console.log(`selected ${value}`);
  };
  const [value1, setValue1] = useState("Apple");

  const [value3, setValue3] = useState("");

  const [value5, setValue5] = useState("");

  const onChange1 = ({ target: { value } }) => {
    setValue1(value);
  };

  const onChange3 = ({ target: { value } }) => {
    setValue3(value);
  };

  const onChange5 = ({ target: { value } }) => {
    setValue5(value);
  };

  const plainOptions = ["227 Clarkson Avenue ", "764 Macon Street "];

  const plainOptions2 = [
    "Defaulted",
    "Dismissed",
    "Paid",
    "Everything",
    "All Due",
    "Imposed",
    "Overpaid",
    "All Closed",
    "Written Off   ",
    "Cured",
    "Reserved",
    "Due Open Correction",
    "Open ",
  ];
  const plainOptions2Filtered = ["Dismissed", "Open"];

  const plainOptions4 = ["Show all", "1st Hearing", "Adjourned"];

  const { Search } = Input;

  const onSearch = (value, _e, info) => console.log(info?.source, value);
  return (
    <div className="main-ECOSidebar">
      <div className="sort-heading-div">
        <Select
          style={{ width: "95%" }}
          placeholder="Sort By: 1st Heading"
          onChange={onChange}
          options={[
            {
              value: "client",
              label: "Client",
            },
            {
              value: "ACB ",
              label: "ACB Voil#",
            },
            {
              value: "adress",
              label: "Adress",
            },

            {
              value: "headingDate",
              label: "Heading Date",
            },

            {
              value: "agency",
              label: "Agency",
            },

            {
              value: "repondent",
              label: "Repondent",
            },
            {
              value: "hiredstonecore",
              label: "Hired Stonecore",
            },
          ]}
        />
      </div>
      <div className="sort-heading-div">
        <h3>Search Violation</h3>
        <Search
          style={{ width: "95%" }}
          placeholder="input search text"
          onSearch={onSearch}
          enterButton
        />
      </div>
      <div className="sort-heading-div">
        <div className="radio-div">
          <h2>Properties</h2>
          <Radio.Group
            options={plainOptions}
            onChange={onChange1}
            value={value1}
          />
        </div>
        <br />
      </div>

      {location.pathname !== "/violations" ? (
        <div className="Status-sidebar">
          <h3 style={{ paddingLeft: "10px" }}>Status</h3>
          <div style={{ marginLeft: "10px" }}>
            <Radio.Group
              style={{ display: "flex", flexDirection: "column" }}
              options={plainOptions2}
              onChange={onChange3}
              value={value3}
            />
          </div>
        </div>
      ) : (
        <div className="Status-sidebar">
          <h3 style={{ paddingLeft: "10px" }}>Status</h3>
          <div style={{ marginLeft: "10px" }}>
            <Radio.Group
              style={{ display: "flex", flexDirection: "column" }}
              options={plainOptions2Filtered}
              onChange={onChange3}
              value={value3}
            />
          </div>
        </div>
      )}

      {location.pathname !== "/violations" && (
        <div className="sort-heading-div">
          <div className="radio-div">
            <h2>Adjourn</h2>
            <Radio.Group
              options={plainOptions4}
              onChange={onChange5}
              value={value5}
            />
          </div>
          <br />
        </div>
      )}

      <div className="sort-heading-div">
        <div style={{ display: "flex" }}>
          <Col span={12}>
            <Form.Item>
              <DatePicker
                style={{
                  width: "90%",
                  height: "40px",
                  marginLeft: "8px",
                }}
                placeholder="From "
              />
            </Form.Item>
          </Col>
          <Col span={12}>
            <Form.Item>
              <DatePicker
                style={{ width: "90%", height: "40px" }}
                placeholder="To"
              />
            </Form.Item>
          </Col>
        </div>
        <Button type="primary">Apply Filter</Button>
      </div>
    </div>
  );
}
